module.exports = __webpack_public_path__ + "img/bank1.b685bdf1.png";